/* eslint-disable */
/**
 * InvestigationResultService.js contains all of the service functions used for the
 * profile performance data.
 *
 * @endpoints /investigationResult/:
 * 		profilePerformance - retrieve the profile performance data
 *
 * @author Sophia Frankel <sophia.frankel@quavo.com>
 */

import API from '@/services/APIService';

export default {
	name: 'InvestigationResultService',
	/**
	 * Retrieve a profile's performance data based on the provided parameters
	 * @param {Object} payload - object containing parameters for the request body
	 * @param {*} dispatch - dispatch a notification in the event of an error
	 * @returns an object containing the profile's profileId, tenantId, disputeData, and claimData
	 */
	retrieveProfilePerformance(payload, dispatch) {
		return API.call('/investigationResult/profilePerformance', {
			tenantId: payload.tenantId,
			profileId: payload.profileId,
			clientId: "Default"
		}).catch(error => {
			dispatch("notifications/addNotification", {
				status: 'error',
				message: 'A ' + error.message + ' has occurred. Please refresh the page or try again later.',
			});
		});
	}
};